import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/view/Home'

Vue.use(Router)

export default new Router({  
mode: 'history',

  routes: [
    {
      path: '/',
      component: HomePage,
      name: 'Home'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js